export const ATSClientTypeConstants = {
  APPLICANT: 'Applicant',
  USER: 'User',
  APPLICANT_AND_USER: 'ApplicantAndUser'

}
